import { useEffect, useState } from 'react';
import { NumericFormat } from 'react-number-format';

import { IconButtonClean } from '@components/core-ui/form-elements/buttons/IconButton/variations/IconButtonClean';
import { FormFieldIcon } from '@components/core-ui/form-elements/FormFieldIcon';
import { FormFieldRoot } from '@components/core-ui/form-elements/FormFieldRoot';
import ErrorIcon from '@components/icons/FormError.svg';
import { TProps } from './types/TProps';

const currencyIconClassName = 'right-[5px] h-auto w-auto';

export const CurrencyInput = ({
  name = 'input',
  icon: Icon,
  label,
  onChange,
  onIconClick,
  value = '',
  placeholder = '',
  required = false,
  disabled = false,
  error = false,
  className = 'form-input w-full',
  handleBlur,
  size,
  onKeyUp,
}: TProps) => {
  const defaultTitle = `${label}${required ? ' *' : ''}`;
  const placeholderTitle = placeholder ? placeholder : defaultTitle;
  const [title, setTitle] = useState(defaultTitle);
  const withIcon = Boolean(Icon) || error;

  const inputClassName = [
    'input form-control inline-block h-10 px-4',
    withIcon ? 'pr-[45px]' : '',
    error ? 'form-control--error' : '',
  ]
    .filter(Boolean)
    .join(' ');

  useEffect(() => {
    onBlur();
  }, [required]);

  const onFocus = () => {
    setTitle(placeholderTitle);
  };

  const onBlur = () => {
    setTitle(defaultTitle);
    handleBlur?.(null);
  };

  const renderIcon = () => {
    if (!Icon) {
      return null;
    }
    if (error) {
      if (!onIconClick) {
        return (
          <FormFieldIcon className={currencyIconClassName}>
            <ErrorIcon />
          </FormFieldIcon>
        );
      }
      return (
        <FormFieldIcon clickable className={currencyIconClassName}>
          <IconButtonClean type="button" onClick={onIconClick}>
            <ErrorIcon />
          </IconButtonClean>
        </FormFieldIcon>
      );
    }
    if (!onIconClick) {
      return (
        <FormFieldIcon className={currencyIconClassName}>
          <Icon />
        </FormFieldIcon>
      );
    }
    return (
      <FormFieldIcon clickable className={currencyIconClassName}>
        <IconButtonClean type="button" onClick={onIconClick}>
          <Icon />
        </IconButtonClean>
      </FormFieldIcon>
    );
  };

  return (
    <FormFieldRoot disabled={disabled} className={className}>
      <NumericFormat
        className={inputClassName}
        onValueChange={(v) => {
          onChange(v.floatValue ?? 0, v.value);
        }}
        allowNegative={false}
        thousandSeparator={true}
        placeholder={title}
        name={name}
        value={value}
        required={required}
        disabled={disabled}
        onFocus={onFocus}
        onBlur={onBlur}
        size={size}
        onKeyUp={onKeyUp}
        prefix="$ "
      />
      {renderIcon()}
    </FormFieldRoot>
  );
};
